<!--
 * @FileDescription: 审核设置（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-01（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div>
      <a-modal  :title="title" class="audit-model"  :maskClosable="false"  v-model="isShowModel"  @ok="onCofrimForm"  @cancel="onCancel">
        <a-form :form="form"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 16 }">
            <a-form-item label="审核人">
                <a-select  v-decorator="['auditorId',{ rules: [{ required: true, message: '请选择审核人'}] },]"
                           placeholder="请选择审核人"
                >
                    <a-icon slot="suffixIcon"  type="caret-down" style="color: #555555" />
                    <a-select-option v-for="item in accountList" :key="item.accountId">
                      <template v-if="!isEmpty(item.loginName) || !isEmpty(item.realName) ">{{item.loginName}}({{item.realName}})</template>
                      <template v-else>{{item.mobile}}</template>
                    </a-select-option>
                </a-select>
            </a-form-item>
            <!--<a-form-item label="是否启用">-->
                <!--<a-radio-group v-decorator="['state',{ rules: [{ required: false}] },]">-->
                    <!--<a-radio value="0">启用</a-radio>-->
                    <!--<a-radio value="1">停用</a-radio>-->
                <!--</a-radio-group>-->
            <!--</a-form-item>-->
        </a-form>
      </a-modal>

  </div>
</template>
<script>
import {voucherUpdate} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AFormItem from "ant-design-vue/es/form/FormItem";
export default {
    mixins:[mixins],
    props:{
    },
    data(){
        return{
            title:'审核设置',
            isShowModel:false,
            form: this.$form.createForm(this),
            recordItem:{}
        }
    },
    watch: {

    },
    mounted () {
        this.accountListSelect()
    },
    created () {

    },
    components: {
        AFormItem,
        ATextarea
    },
    methods: {
        /**
        * @description: 此为方法注释（方法描述）
        * @param {参数类型} 参数名称
        * @return void
        */
        onOpen(record,value){
            this.recordItem = record
            this.recordItem.value= value
           this.isShowModel = true
            if(record.auditorId == 0){
              this.$nextTick(()=>{
                this.form.setFieldsValue({
                  auditorId:undefined,
                })
              })
            }else{
              this.$nextTick(()=>{
                this.form.setFieldsValue({
                  auditorId:record.auditorId,
                  state:record.state
                })
              })
            }
        },
        onCofrimForm(){
            this.form.validateFields((err, values) => {
                if(!err){
                    voucherUpdate({
                        auditorId:values.auditorId,
                        companyStoreId:this.$store.state.shopId,
                        companyId:this.$store.state.companyId,
                        id:this.recordItem.id,
                        voucherType:this.recordItem.voucherType,
                        state:this.recordItem.value ? '1' :'0'
                    },{}).then((res)=>{
                        if(res.success){
                            this.$message.success(res.logMessage)
                            this.$emit('auditpageList')
                            this.isShowModel = false
                        }else{
                            this.$message.warn(res.logMessage)
                        }
                    })
                }
            })
        },
        onCancel(){
            this.isShowModel = false
        },
    },

}
</script>
<style lang="scss">
.audit-model{
    width: 540px !important;
    height: 300px !important;
}
</style>
